import DatabasesResource from 'remote/resources/databases';
import { DatabaseSizeMap } from 'entities/database';

const getAvailableSizes = async (namespaceId: string): Promise<DatabaseSizeMap> =>
  DatabasesResource.getAvailableSizes(namespaceId);

export default getAvailableSizes;
